import { useRoutes } from 'react-router-dom'

export const RenderRouter = ({ routes, location }) =>
  useRoutes(routes, location)
